import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login, { landingFor } from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clienti from "@/pages/Clienti";
import Lead from "@/pages/Lead";
import Prodotti from "@/pages/Prodotti";
import Utenti from "@/pages/Utenti";
import Impianti from "@/pages/Impianti";
import ImpiantoDetail from "@/pages/ImpiantoDetail";
import Contratti from "@/pages/Contratti";
import Manutenzioni from "@/pages/Manutenzioni";
import Interventi from "@/pages/Interventi";
import InterventoDetail from "@/pages/InterventoDetail";
import Rapportino from "@/pages/Rapportino";
import AgendaTecnico from "@/pages/AgendaTecnico";
import PortaleCliente from "@/pages/PortaleCliente";
import Sync from "@/pages/Sync";
import Preventivi from "@/pages/Preventivi";
import Magazzino from "@/pages/Magazzino";
import Listini from "@/pages/Listini";
import Fatture from "@/pages/Fatture";
import VenditeDirette from "@/pages/VenditeDirette";
import Corsi from "@/pages/Corsi";
import CorsoDetail from "@/pages/CorsoDetail";

const Guard = ({ roles, bare, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 overline">Caricamento…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={landingFor(user.role)} replace />;
  return bare ? children : <Layout>{children}</Layout>;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user && user !== true) return <Navigate to={landingFor(user.role)} replace />;
  return <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Guard roles={["azienda", "agente"]}><Dashboard /></Guard>} />
          <Route path="/agenda" element={<Guard roles={["tecnico", "azienda"]}><AgendaTecnico /></Guard>} />
          <Route path="/interventi" element={<Guard roles={["azienda", "tecnico"]}><Interventi /></Guard>} />
          <Route path="/interventi/:id" element={<Guard roles={["azienda", "tecnico"]}><InterventoDetail /></Guard>} />
          <Route path="/interventi/:id/rapportino" element={<Guard roles={["azienda", "tecnico"]} bare><Rapportino /></Guard>} />
          <Route path="/clienti" element={<Guard roles={["azienda", "agente"]}><Clienti /></Guard>} />
          <Route path="/impianti" element={<Guard roles={["azienda", "agente", "tecnico"]}><Impianti /></Guard>} />
          <Route path="/impianti/:id" element={<Guard roles={["azienda", "agente", "tecnico"]}><ImpiantoDetail /></Guard>} />
          <Route path="/manutenzioni" element={<Guard roles={["azienda"]}><Manutenzioni /></Guard>} />
          <Route path="/contratti" element={<Guard roles={["azienda"]}><Contratti /></Guard>} />
          <Route path="/fatture" element={<Guard roles={["azienda"]}><Fatture /></Guard>} />
          <Route path="/vendite" element={<Guard roles={["azienda", "agente"]}><VenditeDirette /></Guard>} />
          <Route path="/formazione" element={<Guard roles={["azienda", "agente"]}><Corsi /></Guard>} />
          <Route path="/formazione/:id" element={<Guard roles={["azienda", "agente"]}><CorsoDetail /></Guard>} />
          <Route path="/lead" element={<Guard roles={["azienda", "agente"]}><Lead /></Guard>} />
          <Route path="/preventivi" element={<Guard roles={["azienda", "agente"]}><Preventivi /></Guard>} />
          <Route path="/magazzino" element={<Guard roles={["azienda"]}><Magazzino /></Guard>} />
          <Route path="/listini" element={<Guard roles={["azienda"]}><Listini /></Guard>} />
          <Route path="/prodotti" element={<Guard roles={["azienda", "agente"]}><Prodotti /></Guard>} />
          <Route path="/utenti" element={<Guard roles={["azienda"]}><Utenti /></Guard>} />
          <Route path="/sync" element={<Guard roles={["azienda"]}><Sync /></Guard>} />
          <Route path="/portale" element={<Guard roles={["cliente"]}><PortaleCliente /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
